import { render, staticRenderFns } from "./QueensLab5_ReportSheet1.vue?vue&type=template&id=e44515fe&"
import script from "./QueensLab5_ReportSheet1.vue?vue&type=script&lang=ts&"
export * from "./QueensLab5_ReportSheet1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VRow,VSimpleTable})
